const toggles = document.querySelectorAll('.specializations-sec__toggle');
const contents = document.querySelectorAll('.specializations-sec__content');
const wrap = document.querySelector('.specializations-sec__wrap');


if(toggles.length && contents.length) {
  toggles[0].classList.add('active');
  contents[0].classList.add('active');

  const setWrapHeight = () => {
    if (!wrap || !contents.length) return;

    let maxHeight = Math.max(...Array.from(contents, c => c.scrollHeight));

    if (maxHeight && isFinite(maxHeight)) {
      wrap.style.minHeight = `${maxHeight}px`;
    }
  }

  setWrapHeight();
  toggles.forEach((toggle, i) => {
    toggle.addEventListener('click', () => {
      if(toggle.classList.contains('active')) return;
      toggles.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));

      toggle.classList.add('active');
      contents[i].classList.add('active');
    })
  })

  window.addEventListener('resize', setWrapHeight);
}


import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let specializationsSwiperWr = document.querySelectorAll('.specializations-swiper-wr');

specializationsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let allowTouchMove = window.innerWidth > 768 && slidesCount <= 4;

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 24,
      slidesPerView: 'auto',
      freeMode: true,
      threshold: 10,
      slideToClickedSlide: true,
      allowTouchMove: !allowTouchMove,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        768: {
        spaceBetween: 38,
        },
        1200: {
          spaceBetween: 70,
        }
      },
      autoplay: false,
    });
  }
});